export enum SubscriptionTabsEnum {
  Plans = 'plans',
  Checkout = 'checkout',
}

export const DEFAULT_DASHBOARD_ROUTE = '/pay-dashboard';
